module.exports = require('./$.global').document && document.documentElement;


//////////////////
// WEBPACK FOOTER
// ./~/vue2-google-maps/~/core-js/library/modules/$.html.js
// module id = ./node_modules/vue2-google-maps/node_modules/core-js/library/modules/$.html.js
// module chunks = 0